type Variant = "hiring" | "sponsor" | "open";

type Props = {
  variant: Variant;
  children?: string;
};

const LABELS: Record<Variant, string> = {
  hiring: "Hiring",
  sponsor: "Sponsor",
  open: "Open",
};

export function StatusPill(props: Props) {
  return (
    <span class={`status-pill status-pill--${props.variant}`}>{props.children ?? LABELS[props.variant]}</span>
  );
}
